import type { InputHTMLAttributes, ReactNode } from 'react';

export interface SearchFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  leading?: ReactNode;
  onClear?: () => void;
}

export function SearchField({
  label = 'Search',
  leading,
  className = '',
  id,
  onClear,
  value,
  ...props
}: SearchFieldProps) {
  const inputId = id ?? 'ui-search';
  return (
    <label className={`ui-search ${className}`.trim()} htmlFor={inputId}>
      <span className="sr-only">{label}</span>
      {leading ?? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
          <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
          <path d="M20 20l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      )}
      <input id={inputId} type="search" value={value} {...props} />
      {onClear && value ? (
        <button type="button" className="ui-btn ui-btn--ghost" style={{ minHeight: 32, padding: '0 0.5rem' }} onClick={onClear} aria-label="Clear search">
          ×
        </button>
      ) : null}
    </label>
  );
}
